import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer, offerHighlights, offerStack, productImages } from '../data/content';
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-4 bg-night-panel" data-id="element-120" data-mp="2pt2b2v482v7f">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-121" data-mp="2kxdaqpkdpaa2">
        <h2 className="text-center font-display text-[1.75rem] font-semibold uppercase leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-122" data-mp="1x5ze47f72sja">
          {offerStack.title}
        </h2>

        <img src={productImages.offer} alt={productImages.offerAlt} className="mx-auto mt-8 h-auto w-full max-w-xl drop-shadow-[0_24px_40px_rgba(0,0,0,0.5)]" data-id="element-123" data-mp="26w0x4ksoxkrc" />

        <div className="mx-auto mt-8 max-w-2xl rounded-2xl border border-gold-soft/45 bg-night p-5 sm:p-7" data-id="element-124" data-mp="1efq265tlvmee">
          <ul className="divide-y divide-dashed divide-night-line" data-id="element-125" data-mp="19hg67t024hrq">
            {offerStack.items.map(item => <li key={item.title} className="flex items-start justify-between gap-4 py-4 first:pt-0 last:pb-0" data-id="element-126" data-mp="14o22juigp53u">
                <p className="flex gap-3 font-sans text-[0.95rem] leading-relaxed text-parchment/85" data-id="element-127" data-mp="1eewqd3bcwcre">
                  <CheckIcon className="mt-1 h-4 w-4 flex-none text-gold-soft" aria-hidden="true" data-id="element-128" data-mp="1jdq32titjzqi" />
                  <span data-id="element-129" data-mp="lqh90a4r5icw">
                    <span className="font-semibold text-parchment" data-id="element-130" data-mp="lr96xrltns6c">{item.title}</span>
                    <span className="text-parchment/60" data-id="element-131" data-mp="qoskepap40x8"> — {item.description}</span>
                  </span>
                </p>
                <span className="mt-0.5 flex-none font-sans text-sm font-semibold text-gold-soft line-through" data-id="element-132" data-mp="vnm08odgg40k">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-6 border-t border-night-line pt-6 text-center" data-id="element-133" data-mp="2730ydvheh1x9">
            <p className="font-sans text-sm text-parchment/60" data-id="element-134" data-mp="2b4477y115xoz">
              Valor total: <span className="line-through" data-id="element-135" data-mp="bzw1vaof9jag">{launchOffer.regularPrice}</span>
            </p>
            <p className="mt-2 font-display text-xl font-semibold text-parchment sm:text-2xl" data-id="element-136" data-mp="71ua81cxkbnd">
              Hoy te llevas todo por:
            </p>
            <p className="font-display text-5xl font-semibold text-gold-soft sm:text-6xl" data-id="element-137" data-mp="l0as8og8tokt">
              {launchOffer.price}
            </p>
            <p className="mt-1 font-sans text-sm font-semibold text-gold" data-id="element-138" data-mp="3ohj6yzfoc8bb">
              {launchOffer.saveLabel}
            </p>
            <p className="mx-auto mt-4 flex w-fit items-center gap-2 rounded-full bg-gold/10 px-4 py-2 font-sans text-xs font-semibold text-gold-soft" data-id="element-139" data-mp="3kh8r8v22y3j9">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="242lthbhv7nx" />
              {launchOffer.note}
            </p>

            <div className="mx-auto mt-7 max-w-md" data-id="element-141" data-mp="35r1gz2m87qtn">
              <CtaButton size="block" href={checkoutUrl} data-id="element-142" data-mp="35pqed64iop44">
                {cta.label}
              </CtaButton>
              <p className="mt-3 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-143" data-mp="30q5emthiwcqc">
                {cta.microcopy}
              </p>
            </div>

            <ul className="mx-auto mt-7 grid max-w-md gap-2 text-left sm:grid-cols-2" data-id="element-144" data-mp="1l15u4eqorx5h">
              {offerHighlights.map(item => <li key={item} className="flex items-start gap-2" data-id="element-145" data-mp="17b2azwn3sjk9">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-soft" aria-hidden="true" data-id="element-146" data-mp="1c7spifj9f73k" />
                  <span className="font-sans text-sm text-parchment/80" data-id="element-147" data-mp="1zz7zmuha2spd">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}